import React from 'react'
import { StepsContext } from '../contexts/Steps'
import { AdOrderContext } from '../contexts/AdOrder'
import { empty, isBool, isString } from '../utils/InputValidation'

export default function useSteps () {
  const { steps, setSteps, currentStep, setCurrentStep, errors, setErrors } = React.useContext(StepsContext)
  const { adOrder } = React.useContext(AdOrderContext)

  const isStep = function (step) {
    return currentStep === step
  }

  const getStep = function (step) {
    return steps[step]
  }

  const getCurrentStep = function () {
    return getStep(currentStep)
  }

  const goToStep = function(step){
    window.scrollTo(0, 0)
    clearErrors()
    if (steps.length > step) {
      if (validateStep(currentStep) === true) {
        setCurrentStep(step)
      }
    } else {
      console.warn('No such step: ' + step)
    }
  }

  const nextStep = function () {
    goToStep(currentStep + 1)
  }
  const prevStep = function () {
    goToStep(currentStep - 1)
  }

  const validateStep = function (step) {
    switch (step) {
      case 0:
        return validateAdInformationStep()
      case 1:
        return validateContactInformationStep()
      case 2:
        return validatePaymentStep()
      default:
        return true
    }
  }

  const clearErrors = function () {
    setErrors(null)
  }

  const validateAdInformationStep = function(){
    let valid = true
    let errors = []

    if(!isString(adOrder.name) || empty(adOrder.name)){
      valid = false
      errors.push('Opgavens navn skal være angivet')
    }

    if(empty(adOrder.date_from)){
      valid = false
      errors.push('Fra dato skal være angivet')
    }
    if(empty(adOrder.date_to)){
      valid = false
      errors.push('Til dato skal være angivet')
    }
    if(empty(adOrder.cities)){
      valid = false
      errors.push('Byer skal være angivet')
    }

    if(!isBool(adOrder.delivered_by_customer)){
      valid = false
      errors.push('Du skal angive om I selv leverer annoncen')
    }

    if(!isString(adOrder.headline) || empty(adOrder.headline)){
      valid = false
      errors.push('Overskrift på annonce skal være angivet')
    }

    if(!isString(adOrder.date) || empty(adOrder.date)){
      valid = false
      errors.push('Dato skal være angivet')
    }

    if(!isString(adOrder.location) || empty(adOrder.location)){
      valid = false
      errors.push('Sted skal være angivet')
    }

    if(!isString(adOrder.url) || (adOrder.url.indexOf('http://') !== 0 && adOrder.url.indexOf('https://') !== 0)){
      valid = false
      errors.push('Link til hjemmesiden skal være angivet og starte med "http://" eller "https://"')
    }

    if(!isString(adOrder.content) || empty(adOrder.content)){
      valid = false
      errors.push('Angiv tekst til annoncen')
    }

    /*if(empty(adOrder.image)){
      valid = false
      errors.push('Vælg et billede til annoncen')
    }*/

    setErrors(errors.length > 0 ? errors : null)
    return valid
  }

  const validateContactInformationStep = function(){
    let valid = true
    let errors = []

    let contact = adOrder.contact

    if(!isString(contact.name) || empty(contact.name)){
      valid = false
      errors.push('Navn skal være angivet')
    }

    if(!isString(contact.company_name) || empty(contact.company_name)){
      valid = false
      errors.push('Firmanavn skal være angivet')
    }

    if(!isString(contact.vat) || empty(contact.vat)){
      valid = false
      errors.push('CVR nummer skal være angivet')
    }

    if(!isString(contact.email) || empty(contact.email)){
      valid = false
      errors.push('Email skal være angivet og gyldig')
    }

    if(!isString(contact.phone) || empty(contact.phone)){
      valid = false
      errors.push('Telefonnummer skal være angivet og gyldig')
    }


    setErrors(errors.length > 0 ? errors : null)
    return valid
  }

  const validatePaymentStep = function(){
    return true
  }

  return {
    currentStepIndex: currentStep,
    getCurrentStep,
    isStep,
    getStep,
    nextStep,
    prevStep,
    goToStep
  }
}